export enum ModalsList {
  none = 'none',
  syncOptions = 'syncOptions',
  leftSideBar = 'leftSideBar',
  settings = 'settings',
  newDrain = 'newDrain',
  newSource = 'newSource',
  editDrain = 'editDrain',
  editSource = 'editSource',
}
